<template>
  <div class="font-jumper">
    <div class="row">
      <div class="col-12">
        <h5 class="bold">{{ $cte("profile.email") }}</h5>
        <div class="field-wrapper">
          <div v-if="!editMode">{{ user.email }}</div>
          <b-form-input
            v-else
            class="profile-input-field"
            type="text"
            v-model="user.email"
            trim
          />
        </div>

        <h5 class="bold">{{ $cte("profile.lastName") }}</h5>
        <div class="field-wrapper">
          <div v-if="!editMode">{{ user.lastName }}</div>
          <b-form-input
            v-else
            class="profile-input-field"
            type="text"
            v-model="user.lastName"
            trim
          />
        </div>

        <h5 class="bold">{{ $cte("profile.firstName") }}</h5>
        <div class="field-wrapper">
          <div v-if="!editMode">{{ user.firstName }}</div>
          <b-form-input
            v-else
            class="profile-input-field"
            type="text"
            v-model="user.firstName"
            trim
          />
        </div>

        <h5 class="bold">{{ $cte("profile.birthDate") }}</h5>
        <div class="field-wrapper">
          <div v-if="!editMode">{{ user.birthDate }}</div>
          <b-form-input
            v-else
            class="profile-input-field"
            type="text"
            placeholder="1970-01-01"
            v-model="user.birthDate"
            v-mask="'####-##-##'"
            trim
          />
        </div>

        <h5 class="bold">{{ $cte("profile.phone") }}</h5>
        <div class="field-wrapper">
          <div v-if="!editMode">{{ user.phone }}</div>
          <b-form-input
            v-else
            class="profile-input-field"
            type="text"
            v-model="user.phone"
            trim
          />
        </div>

        <h5 class="bold">{{ $cte("profile.address") }}</h5>
        <div class="field-wrapper">
          <div v-if="!editMode">{{ user.address }}</div>
          <b-form-input
            v-else
            class="profile-input-field"
            type="text"
            v-model="user.address"
            trim
          />
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end p-2">
      <b-button variant="primary" v-if="!editMode" @click="() => (editMode = true)">{{
        $cte("common.edit")
      }}</b-button>
      <b-button
        variant="secondary"
        v-if="editMode"
        @click="cancelSave"
        class="mx-2"
        >{{ $cte("common.cancel") }}</b-button
      >
      <b-button variant="success" v-if="editMode" @click="saveUser">{{
        $cte("common.save")
      }}</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserEditor",

  props: {
    userData: {},
  },

  data() {
    return {
      editMode: false,
      user: {},
    };
  },

  watch: {
    userData() {
      this.deepCopyUserProp();
    },
  },

  mounted() {
    this.deepCopyUserProp();
  },

  methods: {
    saveUser() {
      this.editMode = false;
      this.$emit("userSave", this.user);
    },

    cancelSave() {
      this.deepCopyUserProp();
      this.editMode = false;
    },

    deepCopyUserProp() {
      this.user = JSON.parse(JSON.stringify(this.userData));

      // Crop date
      if (this.user.birthDate && this.user.birthDate.length > 10) {
        this.user.birthDate = this.user.birthDate.substring(0, 10);
      }
    },
  },

  emits: ["userSave"],
};
</script>

<style scoped>
.field-wrapper {
  min-height: 45px;
}
.field-wrapper div {
  font-family: JumperThin !important;
}

.bold {
  font-weight: bold;
}
</style>
